import React from 'react'
import { IconReceiptOff } from '@tabler/icons-react'
import { Text } from '@mantine/core'
export default function PaymentStatusIcon(status,amount) {
    if(!amount) return <Text c={"gray"}>Aucun remboursement</Text>;
    if(status) return  (<Text c={"green"}>{amount + " $"}</Text>)
    if(status === "canceled") return <IconReceiptOff color='red'/>
    if(!status) return <Text c={"red"}>{amount+ " $"}</Text>
}
